import { useQuery } from '@tanstack/react-query'
import { dataSource } from '../../service/domain/_service.config'
import { useChallengeId } from '../challenge/useChallengeId'

export const EVENTS_QUERY_KEY = (challengeID: string) => ['events', challengeID] as const

export function useEvents() {
  const challengeId = useChallengeId()

  return useQuery({
    queryKey: EVENTS_QUERY_KEY(challengeId),
    queryFn: () => dataSource.getEvents(challengeId),
    enabled: !!challengeId,
  })
}
